module.exports = {
  "小费": "Propina",
  "分钟": "min",
  "优惠券": "Cupón",
  "支付": "Pago",
  "必选": "No es posible desactivar",
  "请选择支付方式": "Por favor, selecciona un método de pago",
  "支付方式": "Payment Method"
}